export class PureOriginalsModel {
    public id: string;
    public status: string;
    public winOlsReference: string;
    public ecuProducer: string;
    public ecuBuild: string;
    public winOlsDbName: string;
    public blobZipName: string;
    public md5: string;
    public sha1: string;
    public sha256: string;
    public clientImportCounter: string;
    public masterUploadCounter: string;
    public dateUploaded: string;
    public numberOfOptions: string;
    public vehicleProducer: string;
    public vehicleSeries: string;
    public vehicleModel: string;
    public vehicleModelYear: string;
    public vehicleBuild: string;
    public ecuSoftwareVersion: string;
    public ecuUse: string;
    public engineDisplacement: string;
    public engineMaxTorque: string;
    public engineName: string;
    public engineProducer: string;
    public engineType: string;
    public engineTransmission: string;
    public outputPs: string;
    public outputKw: string;
    public vehicleType: string;
    public ecuProdNr: string;
    public ecuSoftwareVersionVersion: string;
    public dateUpdated: string;
    public vehicleCharacteristic: string;
    public ecuStgNr: string;
    public projectComment: string;
    public versionComment: string;
    public readingHardware: string;
    public softwareNumber: string;
    public engineEmission: string;
    public projectType: string;
    public dateExported: string




    constructor() {
        this.id = "id";
        this.status = "status";
        this.winOlsReference = "winOlsReference";
        this.ecuProducer = "ecuProducer";
        this.ecuBuild = "ecuBuild";
        this.winOlsDbName = "winOlsDbName"
        this.clientImportCounter = "clientImportCounter";
        this.masterUploadCounter = "masterUploadCounter";
        this.dateUploaded = "dateUploaded";
        this.numberOfOptions = "numberOfOptions";
        this.vehicleProducer = "vehicleProducer";
        this.vehicleSeries = "vehicleSeries";
        this.vehicleModel = "vehicleModel";
        this.vehicleModelYear = "vehicleModelYear";
        this.vehicleBuild = "vehicleBuild";
        this.ecuSoftwareVersion = "ecuSoftwareVersion";
        this.ecuUse = "ecuUse";
        this.engineDisplacement = "engineDisplacement";
        this.engineMaxTorque = "engineMaxTorque";
        this.engineName = "engineName";
        this.engineProducer = "engineProducer";
        this.engineType = "engineType";
        this.engineTransmission = "engineTransmission";
        this.outputPs = "outputPs";
        this.outputKw = "outputKw";
        this.md5 = "md5";
        this.sha1 = "sha1";
        this.sha256 = "sha256";
        this.blobZipName = "blobZipName";
        this.vehicleType = "vehicleType";
        this.ecuSoftwareVersionVersion = "ecuSoftwareVersionVersion";
        this.dateUpdated = "dateUpdated";
        this.ecuProdNr = "ecuProdNr";
        this.vehicleCharacteristic = "vehicleCharacteristic";
        this.ecuStgNr = "ecuStgNr";
        this.projectComment = "projectComment";
        this.versionComment = "versionComment";
        this.readingHardware = "readingHardware";
        this.softwareNumber = "softwareNumber";
        this.engineEmission = "engineEmission";
        this.projectType = "projectType";
        this.dateExported = "dateExported";
    }
}
